<template>
  <article class="edu-wrapper">
    <div class="inner container">
      <div class="text-wrapper">
        <p>글로벌 역량강화 파트너, CARROT GLOBAL</p>
        <p>글로벌 교육은<br />글로벌 교육 전문가에게!</p>
        <p>
          캐럿글로벌은 23년 전 한국 기업들이 글로벌 무대에서<br />성공적인
          비즈니스를 수행할 수 있도록<br />"글로벌 역량" 파트너가 되기로
          결심했습니다.<br /><br />기본적인 언어의 장벽을 넘어,<br />글로벌
          스탠다드에 대한 이해와 이문화 역량의 배양,<br />글로벌 직무역량 강화와
          글로벌 리더십 함양까지<br />300여 종의 글로벌 육성 프로그램을 개발 및
          제공하고 있습니다.<br /><br />또한 글로벌 비즈니스 환경에서
          예측되는<br />다양한 문제들에 대한 Solution을 함께 고민하고,<br />빠르게
          변화하는 글로벌 경영 환경에 대한 트렌드와 지식을 제공함으로써<br />고객들의
          글로벌 성장과 성공의 굳건한 동반자가 될 것입니다.<br /><br />우리의
          존재 이유는 고객들의 'Global Success'라는 것을 잠시도 잊지 않고,<br />세계
          최고의 전문성과 고객지향 정신을 실천할 것을 약속합니다.
        </p>
        <p @click="goInquiry">문의하기</p>
      </div>
      <div class="bg-wrapper">
        <div class="edu-bg">
          <img src="@/assets/img/newGlobal/main/edu/alphabet.png" alt="img" />
        </div>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  methods: {
    goInquiry() {
      document
        .getElementById("inqueryTxtArea")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>
<style lang="scss" scoped>
.edu-wrapper {
  padding: 40px 0px;
  color: #232323;

  .inner {
    .text-wrapper {
      p:nth-child(1) {
        margin-bottom: 14px;
      }
      p:nth-child(2) {
        font-size: 33px;
        font-weight: 700;
        margin-bottom: 48px;
      }
      p:nth-child(3) {
        margin-bottom: 50px;
      }
      p:nth-child(4) {
        display: inline-block;
        font-size: 13px;
        font-weight: 700;
        color: #ff8a18;
        cursor: pointer;
      }
    }

    .bg-wrapper {
      display: none;
    }
  }
}

@media screen and (min-width: 1350px) {
  .edu-wrapper {
    padding: 80px 0px;

    .inner {
      display: flex;
      justify-content: space-between;

      .text-wrapper {
        p:nth-child(1) {
          font-size: 20px;
          margin-bottom: 36px;
        }
        p:nth-child(2) {
          font-size: 50px;
          margin-bottom: 54px;
        }
        p:nth-child(3) {
          font-size: 18px;
        }
        p:nth-child(4) {
          font-size: 20px;
        }
      }

      .bg-wrapper {
        display: block;
        position: relative;

        .edu-bg {
          background: url(~@/assets/img/newGlobal/main/edu/bg.jpg) no-repeat
            center / cover fixed;
        }
      }
    }
  }
}
</style>
